export default value => {
  if (value <= 0) {
    throw new Error('Value must be greater than zero.');
  }
  return Math.floor(1_000_000 / value);
};
